/* dcl-cart-bonus.js  (rev 11)
 * 2026-11-02 (evening), Jake's call: clearance pairs (tag no-discount, or marked
 *   down with compare at above price) no longer earn the card, matching the terms
 *   page. This replaces the 2026-08-29 note below. Open box still excluded.
 * Dialed Cycling Lab, confirms the bonus gift card on the cart page.
 *
 * WHY THIS EXISTS
 * Google Merchant Center requires that a promotion be redeemable at checkout,
 * and that confirmation of receipt appear at cart or checkout. The card is
 * issued by a Shopify Flow workflow that fires on order creation, so the card
 * follows within the hour. This line is what confirms it at the moment of
 * purchase. Checkout itself is not editable on a non-Plus plan, so the cart
 * page is the surface we have.
 *
 * SURFACES
 * There are three ways to reach checkout and this covers two of them:
 *
 *   /cart page        covered, mounts on load
 *   cart drawer       covered, mounts when the drawer opens
 *   Shop Pay direct   NOT covered. Buy It Now goes from the product page straight
 *                     to Shopify's checkout, and checkout UI is not editable
 *                     without Shopify Plus. Those shoppers still see the line on
 *                     the product page before they click.
 *
 * The Alpha Loyalty cart block was removed 2026-08-27, so nothing re-renders the
 * /cart page itself. The drawer is different: it is built on open and torn down on
 * close, so the observer below re-injects each time rather than mounting once.
 *
 * ELIGIBILITY
 * Mirrors the Flow workflow exactly: vendor is Lake Cycling, product tagged
 * Shoes. /cart.js exposes vendor but not tags, so each Lake line is checked
 * against /products/{handle}.js for its tag list. Lake carts are one or two
 * lines, so this is a cheap lookup.
 *
 * The no-discount exclusion was REMOVED 2026-08-29 on Jake's call. Clearance
 * pairs earn the card, so do not add no-discount back. EXCEPTION 2026-11-02,
 * Jake's call: open box pairs (tag Open Box) do NOT earn the card. This file,
 * the Flow, and theme.liquid all exclude the Open Box tag. Otherwise the
 * Merchant Center promotion LAKE-GC-20-2026 covers every Lake shoe, and Google
 * requires receipt be confirmed at cart or checkout for everything in scope.
 *
 * Separately, the DCL_LAKE_OFFER_ELIGIBLE flag in theme.liquid still excludes
 * no-discount and must, because that one drives the 12 percent popup and 12
 * percent must never land on already-marked-down product.
 *
 * If those conditions ever drift from the Flow's, the cart will promise a card
 * the workflow does not send. Keep them in sync.
 *
 * AMOUNT
 * One 20 dollar card per qualifying pair, so the figure shown is 20 times the
 * qualifying quantity in the cart. This must match what the Flow issues. The
 * Flow loops line items and creates one card per qualifying line worth 20 times
 * that line's quantity. Change one and you must change the other.
 */
(function () {
  'use strict';

  if (window.__dclCartBonus) return;
  window.__dclCartBonus = true;

  var VENDOR = 'Lake Cycling';
  var NEED_TAG = 'shoes';
  var SKIP_TAG = 'open box'; // open box pairs never earn the card (2026-11-02)

  var LEAD = 'Your ';
  var TAIL = ' Dialed gift card is emailed once your order is placed.';
  var TAIL_MULTI = ' in Dialed gift cards is emailed once your order is placed.';
  var PER_PAIR = 20;
  var TERMS_HREF = '/pages/shoe-gift-card-terms';
  var TERMS_LABEL = 'Terms';

  // Preferred placement: first child of the cart footer wrapper, which puts the
  // line above the Order note and Estimated shipping accordions where it reads as
  // part of the order rather than a footnote on the checkout button.
  var PREPEND = ['.cart__footer-wrapper', '.cart-drawer__footer', '.drawer__footer'];

  // Fallback: insert before the checkout button. Shopify's cart form requires the
  // name attribute, so it is the most reliable target in any theme.
  var ANCHORS = [
    '[name="checkout"]',
    '.cart__ctas',
    '.cart__footer',
    'form[action$="/cart"] .cart__blocks',
    'form[action$="/cart"]'
  ];

  function anchor(root) {
    for (var i = 0; i < PREPEND.length; i++) {
      var el = root.querySelector(PREPEND[i]);
      if (el) return { el: el, mode: 'prepend' };
    }
    for (var j = 0; j < ANCHORS.length; j++) {
      var b = root.querySelector(ANCHORS[j]);
      if (b) return { el: b, mode: 'before' };
    }
    return null;
  }

  // Containers that may hold a cart. The page itself is always checked; the rest
  // are drawer implementations across common themes.
  var ROOTS = [
    '#CartDrawer',
    'cart-drawer',
    '.cart-drawer',
    '.drawer--cart',
    '#cart-drawer'
  ];

  function icon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '22');
    svg.setAttribute('height', '22');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    ['M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z',
     'M12 8l0 13',
     'M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7',
     'M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5'
    ].forEach(function (d) {
      var p = document.createElementNS(ns, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  function styles() {
    if (document.getElementById('dcl-cb-css')) return;
    var s = document.createElement('style');
    s.id = 'dcl-cb-css';
    s.textContent = [
      '.dcl-cb{display:flex;flex-direction:column;align-items:center;gap:10px;',
      'width:100%;box-sizing:border-box;margin:0;padding:.25rem .75rem 1rem;',
      'text-align:center;font-family:inherit;font-size:.9375rem;line-height:1.45;',
      'opacity:0;transition:opacity .3s ease}',
      '.dcl-cb.is-open{opacity:1}',
      '.dcl-cb__mark{display:flex;align-items:center;justify-content:center;',
      'flex-shrink:0;width:44px;height:44px;border-radius:50%;',
      'background:#1a1a1a;color:#fff!important}',
      '.dcl-cb__text{display:block;max-width:34ch;font-weight:700}',
      '.dcl-cb__amt{color:#e42e0f!important}',
      '.dcl-cb__terms{color:inherit;text-decoration:underline;',
      'text-underline-offset:2px;white-space:nowrap;font-weight:400}',
      '@media (max-width:749px){.dcl-cb{padding:.25rem .5rem .9rem}',
      '.dcl-cb__mark{width:38px;height:38px}}',
      '@media (prefers-reduced-motion:reduce){.dcl-cb{transition:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function mount(root) {
    if (root.querySelector('.dcl-cb')) return;
    var spot = anchor(root);
    if (!spot) return;
    if (spot.mode === 'before' && !spot.el.parentNode) return;

    styles();

    var row = document.createElement('div');
    row.className = 'dcl-cb';
    row.setAttribute('role', 'status');

    var mark = document.createElement('span');
    mark.className = 'dcl-cb__mark';
    mark.appendChild(icon());

    var txt = document.createElement('span');
    txt.className = 'dcl-cb__text';
    txt.appendChild(document.createTextNode(LEAD));
    var amt = document.createElement('span');
    amt.className = 'dcl-cb__amt';
    amt.textContent = '$' + (pairs * PER_PAIR);
    txt.appendChild(amt);
    txt.appendChild(document.createTextNode((pairs > 1 ? TAIL_MULTI : TAIL) + ' '));
    var terms = document.createElement('a');
    terms.className = 'dcl-cb__terms';
    terms.href = TERMS_HREF;
    terms.textContent = TERMS_LABEL;
    txt.appendChild(terms);

    row.appendChild(mark);
    row.appendChild(txt);
    if (spot.mode === 'prepend') spot.el.insertBefore(row, spot.el.firstChild);
    else spot.el.parentNode.insertBefore(row, spot.el);
    requestAnimationFrame(function () { row.classList.add('is-open'); });
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  // A product qualifies on the Shoes tag, unless it is tagged Open Box. Tag
  // comparison is lower-cased because Shopify preserves the casing an admin typed.
  function qualifies(product) {
    if (!product || !product.tags) return false;
    var tags = product.tags.map(function (t) { return String(t).toLowerCase(); });
    if (tags.indexOf(NEED_TAG) === -1 || tags.indexOf(SKIP_TAG) !== -1) return false;
    if (tags.indexOf('no-discount') !== -1) return false; // clearance (2026-11-02)
    if (product.compare_at_price_max && product.compare_at_price_max > product.price_min) return false; // marked down
    return true;
  }

  var eligible = false;
  var pairs = 0;

  // The drawer is rebuilt every time it opens, so watch for a cart appearing
  // anywhere in the document and inject into it. Cheap: the callback exits
  // immediately unless the cart actually qualifies.
  function watchDrawers() {
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      if (!eligible) return;
      mountAll();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function clearAll() {
    var nodes = document.querySelectorAll('.dcl-cb');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
    }
  }

  function mountAll() {
    mount(document);
    for (var i = 0; i < ROOTS.length; i++) {
      var nodes = document.querySelectorAll(ROOTS[i]);
      for (var j = 0; j < nodes.length; j++) mount(nodes[j]);
    }
  }

  function check() {
    getJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;

      var handles = [];
      cart.items.forEach(function (item) {
        if (item.vendor !== VENDOR) return;
        if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
      });
      if (!handles.length) return;

      Promise.all(handles.map(function (h) {
        return getJSON('/products/' + encodeURIComponent(h) + '.js')
          .catch(function () { return null; });
      })).then(function (products) {
        var ok = {};
        for (var i = 0; i < products.length; i++) {
          if (qualifies(products[i])) ok[products[i].handle] = true;
        }
        var count = 0;
        cart.items.forEach(function (item) {
          if (item.vendor !== VENDOR) return;
          if (ok[item.handle]) count += item.quantity;
        });
        if (!count) return;
        // The amount is baked into the rendered node, so a quantity change has to
        // tear the old line down rather than leave a stale figure on screen.
        if (count !== pairs) clearAll();
        pairs = count;
        eligible = true;
        mountAll();
      });
    }).catch(function () {});
  }

  function boot() {
    check();
    watchDrawers();
    // The drawer usually opens right after an add-to-cart, which changes the cart
    // we just read. Re-check on that event so a shoe added mid-session counts.
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[name="add"], form[action*="/cart/add"] [type="submit"]')) return;
      setTimeout(check, 800);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
